import React, {Component} from 'react';
import {images} from 'assets/img/common/common';
import 'assets/sass/common/HeaderMobile.scss';

export class HeaderMobile extends Component {
    render() {
        return (
            <div className="header-mobile">
                <img src={images.logoMobile} alt="Buen Dolar"/>
            </div>
        );
    }
}

